"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmail = isEmail;
exports.isPhone = isPhone;
exports.isValidCode = isValidCode;
exports.isValidId = isValidId;
exports.isValidLogin = isValidLogin;
exports.isValidPhone = isValidPhone;
function isValidPhone(value) {
  if (!value) {
    return false;
  }
  const length = value.replace(/\D+/g, '').length;
  return length === 11;
}
function isPhone(value) {
  const phoneRegexp = /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/;
  return phoneRegexp.test(value);
}
function isEmail(value) {
  // eslint-disable-next-line no-useless-escape
  return /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(value);
}
function isValidId(value) {
  return /^\d+$/.test(value);
}
function isValidLogin(login) {
  return /^\d+$/.test(login) || isEmail(login);
}
function isValidCode(code) {
  return /^\d{4}$/.test(code);
}